import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { api } from "@/lib/api";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const RANK = ["bg-yellow-400 text-black", "bg-zinc-300 text-black", "bg-amber-700 text-white"];

// Public leaderboard: creators ranked by lifetime 🎋 earned via gifts (never balances).
export default function BambooLeaderboard({ highlightId }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/bamboo/leaderboard").then((r) => setData(r.data)).catch(() => setData({ enabled: false, leaderboard: [] })); }, []);
  if (!data || !data.enabled) return null;
  return (
    <div data-testid="bamboo-leaderboard">
      <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">
        Bamboo leaderboard <span className="text-zinc-600 normal-case tracking-normal" data-testid="bamboo-leaderboard-ranked-by">· lifetime 🎋 earned from gifts</span>
      </div>
      {data.leaderboard.length === 0 ? (
        <div className="text-sm text-zinc-500 card-surface p-4 text-center" data-testid="bamboo-leaderboard-empty">No 🎋 earned yet.</div>
      ) : (
        <div className="card-surface divide-y divide-white/5">
          {data.leaderboard.map((row, i) => (
            <Link key={row.user.id} to={`/u/${row.user.id}`} data-testid={`bamboo-leaderboard-row-${row.user.id}`}
              className={`flex items-center gap-3 p-3 hover:bg-white/5 transition ${row.user.id === highlightId ? "bg-emerald-400/5" : ""}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center font-display text-sm shrink-0 ${RANK[i] || "bg-white/5 text-zinc-400 border border-white/10"}`}>{i + 1}</div>
              <Avatar className="w-9 h-9 border border-white/10">
                <AvatarImage src={row.user.avatar_url} />
                <AvatarFallback className="bg-emerald-600 text-white text-xs">{row.user.display_name?.[0]?.toUpperCase()}</AvatarFallback>
              </Avatar>
              <div className="flex-1 min-w-0 flex items-center gap-1 text-sm text-white">
                <span className="truncate">{row.user.display_name}</span>
                {row.user.is_verified && <BadgeCheck size={12} className="text-amber-400 shrink-0" />}
              </div>
              <div className="font-display text-lg text-white shrink-0" data-testid="bamboo-leaderboard-amount">{Number(row.bamboo_earned).toLocaleString()} 🎋</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
